import { useNotNullableContext, useShareUrls } from '../hooks';
import { createContext } from 'react';

export type ShareContext = {
  shareItems: ReturnType<typeof useShareUrls>;
};

export const ShareContext = createContext<ShareContext | null>(null);

export const ShareContextProvider = ShareContext.Provider;

export const useShareContext = () => useNotNullableContext(ShareContext);
